import LearnInToggleView from './LearnInToggle.view';
import {LearnInToggleContainerProps} from './LearnInToggle.interfaces';

function LearnInToggleContainer(props: LearnInToggleContainerProps) {
  return <LearnInToggleView {...props} />;
}

export default LearnInToggleContainer;
